import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "track", "thumb"]
  static classes = ["trackOn", "trackOff", "thumbOn", "thumbOff"]

  connect() {
    this._formResetHandler = this._onFormReset.bind(this)
    this._form = this.element.closest("form")
    if (this._form) {
      this._form.addEventListener("reset", this._formResetHandler)
    }
  }

  disconnect() {
    if (this._resetTimeout) {
      clearTimeout(this._resetTimeout)
      this._resetTimeout = null
    }
    if (this._form && this._formResetHandler) {
      this._form.removeEventListener("reset", this._formResetHandler)
    }
    this._form = null
    this._formResetHandler = null
  }

  toggle() {
    if (this.checkboxTarget.disabled) return

    this.checkboxTarget.checked = !this.checkboxTarget.checked
    this._sync()
    this.dispatch("changed", { detail: { checked: this.checkboxTarget.checked } })
  }

  onKeydown(event) {
    if (event.key === " " || event.key === "Enter") {
      if (event.key === " ") {
        event.preventDefault()
      }
      this.toggle()
    }
  }

  _sync() {
    const isChecked = this.checkboxTarget.checked

    if (isChecked) {
      this.trackTarget.classList.add(...this.trackOnClasses)
      this.trackTarget.classList.remove(...this.trackOffClasses)
      this.thumbTarget.classList.add(...this.thumbOnClasses)
      this.thumbTarget.classList.remove(...this.thumbOffClasses)
    } else {
      this.trackTarget.classList.add(...this.trackOffClasses)
      this.trackTarget.classList.remove(...this.trackOnClasses)
      this.thumbTarget.classList.add(...this.thumbOffClasses)
      this.thumbTarget.classList.remove(...this.thumbOnClasses)
    }

    this.trackTarget.setAttribute("aria-checked", String(isChecked))
  }

  _onFormReset() {
    // Re-sync after a tick to allow the form to reset first.
    // Guard with isConnected to avoid throws after disconnect.
    this._resetTimeout = setTimeout(() => {
      if (this.element.isConnected) {
        this._sync()
      }
      this._resetTimeout = null
    }, 0)
  }
}
